<template>
  <div class="common-layout">
    <el-container>
      <el-header>
        <layout-header />
      </el-header>
      <div class="companySelect" v-show="tabNum == 1 || tabNum == 3">
        <companySelect />
      </div>
      <router-view />
    </el-container>
    <contact-us />
  </div>
  <div class="show_new" v-if="showNew">
    <div class="container">
      <img src="../assets/new.png" />
      <el-icon color="#999a9a" size="18" class="close" @click="close"><Close /></el-icon>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import LayoutHeader from "./layoutHeader.vue";
import companySelect from "./components/companySelect.vue";
import ContactUs from "./contactUs/contactUs.vue";
import { useStore } from "vuex";
import { signalrInit } from "../utils/signalr/index";

const store = useStore();
const token = store.getters.getToken;
const userId = store.getters.getUserinfo("userid");
signalrInit(token, userId);
const tabNum = computed((): any => store.getters.getTabNum);

// 功能上新弹框
const showNew = ref<boolean>(false);
const showNewFn = () => {
  const FutureDay = new Date("2024-02-29");
  const nowDay = new Date();
  const isShowNew = localStorage.getItem("isShowNew");
  if (FutureDay.getTime() > nowDay.getTime() && !isShowNew) {
    showNew.value = true;
  }
};
showNewFn();
const close = () => {
  localStorage.setItem("isShowNew", "true");
  showNew.value = false;
};
</script>
<style lang="less">
.companySelect {
  padding: 5px 0 5px 10px;
  border-top: 2px solid #f5f5f5;
}
.show_new {
  position: absolute;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(#000000, 0.7);
  display: flex;
  justify-content: center;
  overflow-y: scroll;
  .container {
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    margin: auto;
    .close {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }
}
</style>
